import "../../../styles/page/order.scss";

import { TitleTab, TitleTabs } from "../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../common/components/ContentWrapper";
import { Localization } from "../../common/util/localization.jsx";
import MultiEpixSortimentCard from "./MultiEpixSortimentCard.jsx";
import PropTypes from "prop-types";
import React from "react";
import SingleChainSearchBar from "./SingleChainSearchBar.jsx";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class MultiEpixPage extends React.PureComponent {
    constructor(props) {
        super(props);

        this.calculateProductDisplayHeight = this.calculateProductDisplayHeight.bind(this);
        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
        this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);
        this.onEditFilter = this.onEditFilter.bind(this);
    }

    UNSAFE_componentWillMount() {
        const {
            clearMultiEpixSortiment,
            loadChains,
            prepareQueryOptions,
        } = this.props;

        loadChains();
        clearMultiEpixSortiment();
        prepareQueryOptions();
    }

    calculateProductDisplayHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;

        // Page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`]) * 2;

        if (deviceType === "xs") {
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            // Title tab height
            productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);

            // Search bar height
            productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }

        // Product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin) * 2;

        return productDisplayHeight;
    }

    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        let productDisplayWidth = width;
        if (deviceType === "xs") {
            // Page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]) * 2;

            // Product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin) * 2;
        } else {
            // Page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]); // No padding on the right side(Attached to it)

            // Product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin) * 2;
        }

        return productDisplayWidth;
    }

    onEditFilter(...args) {
        const {
            editMultiEpixFilter,
            flowControl,
        } = this.props;
        flowControl(async () => {
            await editMultiEpixFilter(...args);
        });
    }

    loadMoreSearchResults() {
        const {
            deviceType,
            loadMoreMultiEpixSortiment,
        } = this.props;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const rowsToLoad = 4 * (Math.floor(productDisplayHeight / parseInt(scssVariables.productItemHeight)) + 2);
        // rowsToLoad * itemsPerRow
        switch (deviceType) {
        case "xs":
        case "sm":
            this.props.flowControl(async () => { await loadMoreMultiEpixSortiment(rowsToLoad * 2); });
            break;
        case "md":
            this.props.flowControl(async () => { await loadMoreMultiEpixSortiment(rowsToLoad * 4); });
            break;
        case "lg":
            this.props.flowControl(async () => { await loadMoreMultiEpixSortiment(rowsToLoad * 6); });
            break;
        default:
            this.props.flowControl(async () => { await loadMoreMultiEpixSortiment(rowsToLoad * 8); });
            break;
        }
    }

    render() {
        const {
            chains,
            clearEpixProductDetails,
            deviceType,
            editMultiEpixFilter,
            height,
            localization,
            setModal,
            setDropDown,
            multiEpixSortiment,
            updateChainProducts,
            exportCsv,
        } = this.props;

        const productDisplayHeight = this.calculateProductDisplayHeight();
        const productDisplayWidth = this.calculateProductDisplayWidth();

        // const availableTabs = {
        //     all: true,
        //     new: true,
        // };

        const filter = {
            onlyNews: false,
            productGroupId: null,
            supplierId: null,
        };

        return (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{ display: "flex", height: "100%" }} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("chain", "menu", "chainSortiment")} url={"/chainwebMulti/chainsortiment"} deviceType={deviceType} />
                            <TitleTab label={localization.text("chain", "menu", "epixSortiment")} url={"/chainwebMulti/epixsortiment"} deviceType={deviceType} />
                        </TitleTabs>
                        <SingleChainSearchBar
                            deviceType={deviceType}
                            filter={{
                                ...multiEpixSortiment.filter,
                                ...filter
                            }}
                            localization={localization}
                            onEdit={this.onEditFilter}
                            productGroups={multiEpixSortiment.productGroups}
                            productSuppliers={multiEpixSortiment.productSuppliers}
                            setModal={setModal}
                            setDropDown={setDropDown}
                            useFilter={true}
                            useSingleEpix={false}
                            useMultiChain={false}
                            useMultiEpix={true}
                        />
                        <MultiEpixSortimentCard
                            chains={chains}
                            clearEpixProductDetails={clearEpixProductDetails}
                            deviceType={deviceType}
                            editMultiEpixFilter={editMultiEpixFilter}
                            height={productDisplayHeight}
                            loadMoreSearchResults={this.loadMoreSearchResults}
                            localization={localization}
                            setModal={setModal}
                            multiEpixSortiment={multiEpixSortiment}
                            width={productDisplayWidth}
                            updateChainProducts={updateChainProducts}
                            exportCsv={exportCsv}
                        />
                    </div>
                </div>
            </ContentWrapper>);
    }
}

MultiEpixPage.propTypes = {
    chains: PropTypes.object.isRequired,
    clearEpixProductDetails: PropTypes.func.isRequired,
    clearMultiEpixSortiment: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    editMultiEpixFilter: PropTypes.func.isRequired,
    flowControl: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    loadChains: PropTypes.func.isRequired,
    loadMoreMultiEpixSortiment: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    prepareQueryOptions: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    multiEpixSortiment: PropTypes.object.isRequired,
    updateChainProducts: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    exportCsv: PropTypes.func.isRequired,
};

export default withRouter(MultiEpixPage);
